module.exports = __webpack_public_path__ + "static/media/1.344be5da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/existLogos/1.jpg
// module id = 977
// module chunks = 4